/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/256-frustrated': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5.724 4.428c-.543-.271-1.08-.407-1.102-.413a.5.5 0 10-.242.97c.275.07.602.189.89.334A.998.998 0 006.002 7a1 1 0 001-1L7 5.946c-.032-.741-.706-1.234-1.275-1.518z"/><path pid="1" d="M8 0a8 8 0 100 16A8 8 0 008 0zM3.695 12.87c.167.083.356.13.555.13h7.5c.199 0 .387-.047.555-.13C11.158 13.884 9.651 14.5 8 14.5s-3.158-.616-4.305-1.63zM4 11.75v-1.5c0-.136.114-.25.25-.25H6v2H4.25a.253.253 0 01-.25-.25zM7 12v-2h2v2H7zm3 0v-2h1.75c.136 0 .25.114.25.25v1.5c0 .136-.114.25-.25.25H10zm2.87.305c.083-.167.13-.356.13-.555v-1.5C13 9.561 12.439 9 11.75 9h-7.5C3.561 9 3 9.561 3 10.25v1.5c0 .199.047.387.13.555a6.5 6.5 0 119.74 0z"/><path pid="2" d="M11.379 4.015c-.023.006-.559.141-1.102.413-.568.284-1.243.776-1.275 1.518L9 6a1 1 0 101.732-.681c.288-.144.614-.264.89-.334a.5.5 0 10-.242-.97z"/>'
  }
})
